import { isValid, parse } from 'date-fns';
import { TIME_ONLY_FORMATS } from '../../../../constants';

// API can send a time-only value (e.g. "23:59:59") for a dateTime field; anchor it to today so the picker renders instead of choking on Invalid Date.
export const parseTimeOnlyValue = (value: string): Date | null => {
  if (value.includes('T') || value.includes('-')) return null;

  for (const timeFormat of TIME_ONLY_FORMATS) {
    const parsed = parse(value, timeFormat, new Date());
    if (isValid(parsed)) return parsed;
  }

  return null;
};
